export function CoworkingWorkplaceBanner($scope, deviceService, coworkingService) {
  'ngInject';
  $scope.lkUrl = coworkingService.getLkUrl();
  $scope.isMobile = deviceService.isMobile;

  $scope.$watch(() => coworkingService.getWorkplaceData(), ({ cardUrl, addformUrl }) => {
    $scope.cardUrl = cardUrl;
    $scope.addformUrl = addformUrl;
  });
}
